import React from "react";
import styled from "styled-components";
import { store } from "./store.js";

const Status = () => {
  const globalState = React.useContext(store);
  const { balance, number } = globalState.state.account;
  const { amount } = globalState.state;

  const showAmount = () => {
    if (amount === 0) {
      return;
    }

    // const beginningBalance = balance === "--" ? 0 : parseInt(balance, 10);
    const beginningBalance = parseInt(balance, 10) * 100;
    const amountToAdd = parseInt(amount, 10) * 100;

    const newBalance = (beginningBalance + amountToAdd) / 100;

    return (
      <div>
        <strong>New Balance:</strong>
        <br /> ${newBalance}
      </div>
    );
  };
  if (!number) {
    return <div />;
  }

  return (
    <StyledStatus>
      <h2>Transaction Summary</h2>
      <div>
        <strong>Account:</strong>
        <br /> {number}
      </div>
      <div>
        <strong>Current Balance:</strong>
        <br /> ${balance}
      </div>
      {showAmount()}
    </StyledStatus>
  );
};

export default Status;

const StyledStatus = styled.div`
  background-color: #fafafa;
  flex: 1 1 100%;
  padding: 15px;
  /* margin-left: -100%; */

  > div {
    margin-bottom: 15px;
  }
`;
